export default {
    dataModel: {
      types: ['cdlt:PublicationStatus'],
      fieldsMapping: {
        title: 'pair:label'
      }
    },
  };
  